import $ from "jquery";
import Template from "./SendToEmailPopup.ejs";
import Cookies from '../../cookies';
import makeTemplateFunc from "lodash/template";

const TemplateFunc = makeTemplateFunc(Template);

class SendToEmailPopup {

    constructor() {
        this.recaptchaResponse = null;
        $(document).on('click', '.js-send-to-email', (e) => {
            e.preventDefault();
            this.apiUrl = $('.js-send-to-email').data('form-api');
            this.openPopup();
        })

        window.onRecaptchaResponse = (token) => {
            this.recaptchaResponse = token;
        };
    }

    openPopup() {

        const popupTemplate = TemplateFunc();
        const apiUrl = this.apiUrl;


        jQuery.validator.addMethod("checkEmail", function(value, element) {
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            return pattern.test(value);
        });

        if ($('#send-to-email').length  === 0) {
            $(popupTemplate).appendTo('body');
        }
        $(popupTemplate).appendTo('body');
        $('#send-to-email').addClass('open');
        $('.modal-bg').fadeIn().addClass('open');

        var dataCookie = Cookies.getCookie('FILICITY_SM_utm_info');
        if(dataCookie)
        {
            dataCookie = JSON.parse(dataCookie);
            $('#personal-email').val(dataCookie['email']);
        }

        $('#send-to-email-form').validate({
            errorClass: "error",
            validClass: "success",
            errorElement: "em",
            focusInvalid: false,
            rules: {
                email: {
                    required: true,
                    checkEmail: true
                }
            },
            messages: {
                name: {
                    required: "",
                    checkEmail: ""
                }
            },
            invalidHandler: (event, validator) => {
                const errors = validator.numberOfInvalids();
                if (errors) {
                }
            },
            submitHandler: () => {
                $.ajax({
                    url: apiUrl,
                    method: 'POST',
                    data: {
                        email: $("#personal-email").val(),
                        'g-recaptcha-response': this.recaptchaResponse
                    },
                    dataType: 'json',
                    success: (data) => {
                        if (data.error) {
                            console.error(data);
                        } else {
                            $('.modal.open').removeClass('open');
                            $('#send-to-email-success').find('#send-email').text(data.email);
                            $('#send-to-email-success').addClass('open');
                        }
                    },
                    error: (data) => {
                        console.error(data);
                    }
                });
            },
            highlight: (element, errorClass, validClass) => {
                $(element).addClass(errorClass).removeClass(validClass);

            },
            unhighlight: (element, errorClass, validClass) => {
                $(element).removeClass(errorClass).addClass(validClass);
            },

            errorPlacement: (error, element) => {

            }
        });
    }
}

export default new SendToEmailPopup();


// WEBPACK FOOTER //
// ./js/components/SendToEmailPopup/SendToEmailPopup.js